// extracted by mini-css-extract-plugin
module.exports = {"mobileItem":"styles_mobileItem__1IbGD","header":"styles_header__1YRo3","amount":"styles_amount__2cPOs","dates":"styles_dates__3452Q"};